import Vue from 'vue'
import App from './App'
import router from './utils/router.js'
import store from './utils/store.js'
import * as common from './utils/common.js'
import antD from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'mango-css'
import phocusUtiljs from 'phocus-js'
import * as http from './utils/http.js'
import VueResource from 'vue-resource'
//日期格式化
import moment from 'moment'
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

Vue.prototype.$moment = moment

const Base64 = require('js-base64').Base64


// element-ui
require('./utils/compos.js')
Vue.use(antD)
Vue.prototype.$ = phocusUtiljs
require('./utils/http.js')
Vue.config.productionTip = false
/* 注册HTTP方法 */
Object.keys(http).forEach(key => {
  Vue.prototype[key] = http[key]
})
/* 注册自定义方法 */
Object.keys(common).forEach(key => {
  Vue.prototype[key] = common[key]
})
Vue.use(VueResource)

/* eslint-disable no-new */
new Vue({
  // el: '#app',
  router,
  store,
  Base64,
  created () {
    let that = this
    this.setWindowSize()
    window.onresize = function () {
      that.setWindowSize()
    }
  },
  methods: {
    /*
    * 设置窗口高度
    */
    setWindowSize () {
      let windowData = {
        w: this.size('innerWidth'),
        h: this.size('innerHeight')
      }
      this.$store.commit('windowResize', windowData)
    }
  },
  components: { App },
  template: '<App/>',
  render: (h) => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js